import React, { useState } from "react";
import {
    GridRenderEditCellParams,
    useGridApiContext,
} from "@mui/x-data-grid-premium";
import { MuiSingleDateTimePicker } from "../muiSingleDateTimePicker";

export const MuiDataGridDateTimePicker = ({
    id,
    field,
    value,
    hasFocus,
}: GridRenderEditCellParams) => {
    const [open, setOpen] = useState(hasFocus);
    const apiRef = useGridApiContext();

    const handleValueChange = async(newValue: string) => {
        await apiRef.current.setEditCellValue({
            id,
            field,
            value: newValue,
        });
    };

    return (
        <MuiSingleDateTimePicker
            open={open}
            setOpen={(open) => setOpen(open)}
            value={value}
            onChange={(val) => void handleValueChange(val)}
            fullWidth
            disableInputAdornment
            showCloseIcon
            textFieldProps={{
                size: "small",
                variant: "standard",
                sx: { fontSize: "0.875rem" },
            }}
        />
    );
};
